import Text from '../Text'
import { ListProps } from './props'
import { StyledList } from './styles'

/**
 * Create an ordered list (ol) or unordered list (ul)
 * @param items List of items
 * @param listType Type of list - ol | ul
 * @param listStyleType Type of list style
 */
const List = ({ items, listStyleType, listType, ...props }: ListProps) => (
    <StyledList
        as={listType}
        css={{ ...props.css, listStyleType: listStyleType }}
        {...props}
    >
        {items.map((item, index) => (
            <li key={index}>
                <Text>{item}</Text>
            </li>
        ))}
    </StyledList>
)

export default List

export { StyledList }
